import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";

const state = {
  directorates: [],
  directorate: {},
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
};
const getters = {
  directoratesGet: (state) => state.directorates,
  directorate: (state) => state.directorate,
};
const actions = {
  getAllDirectorates({ commit }) {
    service.getFun("directorates").then(
      (obj) => {
        var result = obj?.data;
        commit("setDirectorates", result);
      },
      (error) => {
        console.log("directorates..." + error);
        toastError(error);
      }
    );
  },
  addDirectorate({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `directorates`, null, {
        action: "getAllDirectorates",
      })
      .then(
        (result) => {
          commit("addStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  getDirectorateById({ commit }, payload) {
    service.getFun(`directorates/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("directorateById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  editDirectorate({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `directorates/${payload.id}`,
        null,
        {
          action: "getAllDirectorates",
        }
      )
      .then(
        (result) => {
          commit("editStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteDirectorate({ commit }, payload) {
    service
      .deleteFun(`directorates/${payload.payload}`, {
        action: "getAllDirectorates",
      })
      .then(
        (result) => {
          commit("deleteStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  setDirectorates(state, Directorates) {
    state.directorates = Directorates;
  },
  addStatus(state, status) {
    state.addStatus = status;
  },
  directorateById(state, directorate) {
    state.directorate = directorate;
  },
  editStatus(state, status) {
    state.editStatus = status;
  },
  deleteStatus(state, status) {
    state.deleteStatus = status;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
